// import { io } from 'socket.io-client';
// import { API_BASE_URL } from './api';
// import { getStoredAuthToken } from './utils/authToken';

// export const createNotificationSocket = (user) => {
//   if (!user) return null;

//   const token = getStoredAuthToken();
//   if (!token) return null;

//   const SOCKET_URL =
//     import.meta.env.VITE_SOCKET_URL ||
//     'ws://vms-socket.elsnerdev.co';

//   return io(SOCKET_URL, {
//     transports: ['websocket'],
//     auth: {
//       token,
//       role: user.role,
//       userId: user.id
//     }
//   });
// };

import { io } from 'socket.io-client';
import { getStoredAuthToken } from './utils/authToken';

export const createNotificationSocket = (user) => {
  if (!user) return null;

  // IMPORTANT: never fallback to ws:// in production
  let SOCKET_URL = import.meta.env.VITE_SOCKET_URL;

  if (!SOCKET_URL) {
    console.error('VITE_SOCKET_URL is missing');
    return null;
  }

  // Fix for Mixed Content error: Auto-upgrade to secure protocol if page is HTTPS
  const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
  if (isSecure) {
    SOCKET_URL = SOCKET_URL.replace(/^http:\/\//i, 'https://');
    SOCKET_URL = SOCKET_URL.replace(/^ws:\/\//i, 'wss://');
  }

  // Connection options mirror econnect's socketManager for resilient delivery.
  return io(SOCKET_URL, {
    query: {
      userId: user.id || user._id,
      role: user.role
    },
    transports: ['websocket', 'polling'], // websocket first, polling as fallback
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000,
    upgrade: true,
    rememberUpgrade: true,
    secure: isSecure
  });
};